// @generated-imports
import { closeGameModal } from './app.js';
import { closeBackupModal } from './backup.js';
import { closeCollectionsPanel } from './collections.js';
import { dom, state } from './core.js';
import { closeDeviceCheck } from './devicecheck.js';
import { closeWhatsNew } from './display.js';
import { gpBackupMove, gpPickerMove, gpPickerOptions } from './gamepad.js';
import { cancelPrompt, closeConfirmLayer, cycleFocusIn, registerLayer, submitPrompt } from './layers.js';
import { closeImportQueue, closeLibraryEdit } from './library.js';
import { closePlayersModal } from './multiplayer.js';
import { closePadTest } from './padtest.js';
import { closePauseMenu } from './pausemenu.js';
import { closeHelpModal, closeSettingsModal } from './platform.js';
import { closeProfilesPanel } from './profiles.js';
import { closeStatesPanel } from './states.js';
import { closeStatsPanel } from './stats.js';
import { closeCorePicker } from './zipdetect.js';
// @generated-imports
/* ===========================================================================
   REGISTRO DAS CAMADAS (v2.0)
   ======================================================================== */

function registerAppLayers() {
  registerLayer({
    id: 'game', element: dom.gameModal, card: dom.gameModal.querySelector('.game-modal-card'),
    close: closeGameModal, confirm: () => dom.gameModalPlay.click(),
    legend: [['A', 'Jogar'], ['B', 'Voltar']],
  });
  registerLayer({
    id: 'backup', element: dom.backupModal, card: dom.backupModal.querySelector('.backup-card'),
    close: closeBackupModal, move: gpBackupMove,
    legend: [['A', 'Acionar'], ['B', 'Fechar'], ['↕', 'Navegar'], ['↔', 'Seção']],
  });
  registerLayer({
    id: 'core-picker', element: dom.corePicker, card: dom.corePicker.querySelector('.core-picker-card'),
    close: closeCorePicker,
    confirm: () => { const options = gpPickerOptions(); const focused = options[state.gpPickerIndex] || options[0]; if (focused) focused.click(); },
    move: gpPickerMove,
    legend: [['A', 'Escolher'], ['B', 'Cancelar'], ['↕↔', 'Navegar']],
  });
  if (dom.helpModal) {
    registerLayer({ id: 'help', element: dom.helpModal, card: dom.helpModal.querySelector('.panel-card'), close: closeHelpModal, legend: [['B', 'Fechar'], ['↕', 'Rolar']] });
  }
  if (dom.settingsModal) {
    registerLayer({ id: 'settings', element: dom.settingsModal, card: dom.settingsModal.querySelector('.panel-card'), close: closeSettingsModal, legend: [['A', 'Alternar'], ['B', 'Fechar'], ['↕', 'Navegar']] });
  }
  if (dom.confirmLayer) {
    registerLayer({ id: 'confirm', element: dom.confirmLayer, card: dom.confirmLayer.querySelector('.panel-card'), close: closeConfirmLayer, legend: [['A', 'Escolher'], ['B', 'Cancelar'], ['↔', 'Opções']], move: (dir) => cycleFocusIn(dom.confirmLayer.querySelector('.panel-card'), dir === 'left' ? 'up' : dir === 'right' ? 'down' : dir) });
  }
  if (dom.statesModal) {
    registerLayer({ id: 'states', element: dom.statesModal, card: dom.statesModal.querySelector('.panel-card'), close: closeStatesPanel, legend: [['A', 'Acionar'], ['B', 'Fechar'], ['↕', 'Navegar']] });
  }
  if (dom.playersModal) {
    registerLayer({ id: 'players', element: dom.playersModal, card: dom.playersModal.querySelector('.panel-card'), close: closePlayersModal, legend: [['Qualquer botão', 'Identifica o jogador'], ['B', 'Pular']] });
  }
  if (dom.importQueueModal) {
    registerLayer({ id: 'import-queue', element: dom.importQueueModal, card: dom.importQueueModal.querySelector('.panel-card'), close: closeImportQueue, legend: [['B', 'Fechar']] });
  }
  // v2.1
  const card = (el) => (el ? el.querySelector('.panel-card') : null);
  const simple = (id, element, close, legend, extra = {}) => {
    if (element) registerLayer(Object.assign({ id, element, card: card(element), close, legend }, extra));
  };
  simple('pause', dom.pauseMenu, () => closePauseMenu(), [['A', 'Escolher'], ['B', 'Voltar ao jogo'], ['↕', 'Navegar']]);
  simple('prompt', dom.promptLayer, cancelPrompt, [['A', 'Confirmar'], ['B', 'Cancelar']], {
    confirm: () => { const active = document.activeElement; if (active && active.tagName === 'BUTTON') active.click(); else submitPrompt(); },
  });
  simple('profiles', dom.profilesModal, closeProfilesPanel, [['A', 'Escolher'], ['B', 'Fechar'], ['↕', 'Navegar']]);
  simple('stats', dom.statsModal, closeStatsPanel, [['B', 'Fechar'], ['↕', 'Navegar']]);
  simple('collections', dom.collectionsModal, closeCollectionsPanel, [['A', 'Acionar'], ['B', 'Fechar'], ['↕', 'Navegar']]);
  simple('pad-test', dom.padTestModal, closePadTest, [['Segure B', 'Fechar'], ['Qualquer botão', 'Testar']], { passive: true });
  simple('device-check', dom.deviceCheckModal, closeDeviceCheck, [['A', 'Acionar'], ['B', 'Fechar']]);
  simple('whats-new', dom.whatsNewModal, closeWhatsNew, [['B', 'Fechar']]);
  if (dom.libraryEditModal) {
    registerLayer({ id: 'library-edit', element: dom.libraryEditModal, card: dom.libraryEditModal.querySelector('.panel-card'), close: closeLibraryEdit, legend: [['A', 'Acionar'], ['B', 'Cancelar'], ['↕', 'Campos']] });
  }
}

// @generated-exports
export { registerAppLayers };
// @generated-exports
